import React, { useEffect } from "react";
import CloseIcon from "@material-ui/icons/Close";
import DocumentFlow from "src/app/docFlows/domains/documentFlow/documentFlow";
import { DocFlowItem } from "src/app/docFlows/domains/prpo/poItem";
import { getCondtions, removeDecimal } from "../../helper";
import { DISPATCH_TYPES } from "../../EditRequestAllLinesWrapper";
import { useFetchcXMLData } from "src/app/docFlows/hooks/docflow.hooks";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { FullSizeLoading } from "src/app/shared/components/loading";
import { cXMLData } from "src/app/shared/domains/master/cXMLData";

type AddMaterialFromLsl_CXMLProps = {
  currencyDecimals: any;
  lineItems: DocFlowItem[];
  documentFlow: DocumentFlow;
  setOpenLslPopUp_CXML: Function;
  dispatchMethod: any;
  sessionId: string;
};

export const AddMaterialFromLsl_CXML = (
  props: AddMaterialFromLsl_CXMLProps
) => {
  const {
    currencyDecimals,
    lineItems,
    documentFlow,
    setOpenLslPopUp_CXML,
    dispatchMethod,
    sessionId
  } = props;

  const firstLineItem = lineItems[0];
  console.log(sessionId);
  const lastLineItem = lineItems[props.lineItems?.length - 1];
  const fieldLevelConditions = getCondtions(firstLineItem);

  const { data: cXMlData, isLoading } = useFetchcXMLData(sessionId);

  function handleClose() {
    setOpenLslPopUp_CXML(null);
  }

  useEffect(() => {
    if (cXMlData) {
      console.log(cXMlData);
      if (cXMlData.length > 0) {
        cXMlData.forEach(candexItem => {
          addcXmlItem(candexItem);
        });
      }
      handleClose();
    }
  }, [cXMlData, isLoading]);

  const addcXmlItem = (item: cXMLData) => {
    let tempQty = item.PrQuantityRaw;
    let finalPrice = item.PrPriceRaw || 0;
    let finalTempNetPriceUnit = item.PrNetPriceUnit;

    if (item?.PrCurrency) {
      const tempDecimal: {
        currency: string;
        decimal: string;
      } = currencyDecimals?.filter(
        curr => curr.currency === item?.PrCurrency
      )[0];
      const decimal = tempDecimal?.decimal
        ? parseInt(tempDecimal?.decimal)
        : null;
      finalPrice = removeDecimal(item.PrPriceRaw, decimal);
      finalTempNetPriceUnit = removeDecimal(item.PrNetPriceUnit, decimal);
    }

    const newTotal: number = isNaN(
      (finalPrice * tempQty) / finalTempNetPriceUnit
    )
      ? 0
      : (finalPrice * tempQty) / finalTempNetPriceUnit;
    delete item["status"]; // this is to avoid sending supplier status to sap
    const payload: any = {
      ...lastLineItem,
      ...item,
      CopiedItemNo: lastLineItem.PrItem,
      PrPrice: newTotal,
      PrRequisitioner: documentFlow.Requisitioner,
      PrReqFname: documentFlow.Reqfnam,
      PrReqLname: documentFlow.Reqlnam,
      // PrDeliveryDate: "",
      // PrQuantityRaw: fieldLevelConditions.isItFO ? 1 : "",
      // Taxcode: "",
      isItCopiedLineItem: true, // this is just to ensure system treats this similar to the item added from PSL
      isItAddedFromPsl: true, // this is just to ensure system treats this similar to the item added from PSL
      isItAddedFromCXml: true, // this is just to ensure system treats this similar to the item added from CXML
      isSupplierStatusMandatoryOrSoleSource: false,
      // Supplier: item.vendorNo === "999999999" ? documentFlow.VendorNo : item.vendorNo?.padStart(10, '0'),
      GrQty: "0.000",
      IrAmount: "0.000",
      PR_From_Item: (item as any).PR_From_Item || "PUNCHOUT CATALOG"
    };
    // if (newItem.status === 'Mandatory' || newItem.status === 'SoleSource') {
    //     payload["isSupplierStatusMandatoryOrSoleSource"] = true;
    // }
    if (fieldLevelConditions.isItFO) {
      payload["PrPriceRaw"] = finalPrice;
      delete payload["PrNetPriceRaw"];
    } else {
      payload["PrNetPriceRaw"] = finalPrice;
      delete payload["PrPriceRaw"];
    }
    dispatchMethod({
      type: DISPATCH_TYPES.ADD_NEW_ITEM_LINE,
      payload: payload
    });
  };

  return (
    <Dialog
      open={true}
      maxWidth={"lg"}
      scroll={"paper"}
      fullWidth={true}
      style={{ width: "auto", height: "auto" }}
      closeAfterTransition={false}
    >
      <div style={{ backgroundColor: "orange" }}>
        <DialogTitle>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ color: "white" }}>Add New Line From Supplier</span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer"
              }}
            >
              <CloseIcon onClick={handleClose} style={{ color: "white" }}>
                close
              </CloseIcon>
            </div>
          </div>
        </DialogTitle>
      </div>
      <DialogContent>
        <FullSizeLoading text={"Waiting for data from Supplier"} />
      </DialogContent>
    </Dialog>
  );
};
